import React from 'react';
import styled from 'styled-components';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { purple } from '@zocdoc/branding/colors';

const VirtualVisitMessage = ({ isMobileOrTablet }) => {
    return isMobileOrTablet ? (
        <VirtualVisitText>VIDEO</VirtualVisitText>
    ) : (
        <VirtualVisitText>VIDEO VISIT</VirtualVisitText>
    );
};

const VirtualVisitText = styled.div`
    font: 9px ${FontFamily.SharpSansSemibold};
    color: ${purple};
    border: 1px solid ${purple};
    border-radius: 2px;
    float: right;
    padding: 4px 6px;
    white-space: nowrap;
    margin-left: 12px;
    letter-spacing: 0.11em;
`;

export default VirtualVisitMessage;
